module.exports = __webpack_public_path__ + "media/images/default/pages/depth_views/1-9a6597570168479b344cbbfa393665e4.jpg";